jQuery(function() {
  	/* MEGA MENU WIRES START HERE */
	function mega_menu() {
    	jQuery(".catalog_dropdown").find(".site-nav--has-dropdown").hover(function() {
        	jQuery(".site-nav__dropdown__dropdown").each(function() {
           	  if (jQuery(this).css("display") != "none") {
                jQuery(this).hide();
              }
            });
          	var c_menu = jQuery(this).closest(".catalog_dropdown");
            var d_menu = jQuery(this).find(".site-nav__dropdown__dropdown");
            var e_menu = c_menu.offset();
            d_menu.css("left", jQuery(".catalog_dropdown").width() + 18);
            d_menu.css("width", jQuery(window).width() - jQuery(".catalog_dropdown").width() - 100);
            

            var image_column = jQuery(this).find(".subcategory_column.image_column");
          	if (jQuery(window).width() > 991) {
          		d_menu.css("height", jQuery(".catalog_dropdown").height() + 22);
              	image_column.css("height", d_menu.height());
          		image_column.css("margin-top", -70);
          	}
          	else {
          		image_column.css("height", 400);
              	c_menu.css("height", d_menu.height()+30);
            }
            if (d_menu.css("display") == "none") {
              d_menu.stop(true, true).show(0, function() {
                d_menu.offset({ top: e_menu.top });
              });
            }
        });
        jQuery(".Catalog").click(function(e) {
          if (jQuery(".general_overlay").css("display") == "none") {
            jQuery(".general_overlay").fadeIn(250, function() {
              jQuery(this).click(function() {
                jQuery(this).fadeOut(250);
                jQuery(".catalog_dropdown").fadeOut(250);
              });
            });
          }
          else {
            jQuery(".general_overlay").fadeOut(250);
          }
          if (jQuery(".catalog_dropdown").css("display") == "none") {
            jQuery(".catalog_dropdown").css("top", jQuery("header").height() + 1);
            jQuery(".catalog_dropdown").stop(true, true).fadeIn(250);
          }
          else {
            e.preventDefault();
            jQuery(".catalog_dropdown").stop(true, true).fadeOut(250);
          }
        });
    }
    mega_menu();
    /* MEGA MENU WIRES END HERE */
  	
  	/* Filters Drawer Wires */
  	jQuery(".filters_drawer").find("h3").find("i").click(function() {
        if (jQuery(this).attr("class") == "fa fa-minus-square") {
        	jQuery(this).attr("class", "fa fa-plus-square");
        }
        else {
        	jQuery(this).attr("class", "fa fa-minus-square");
        }
      	
    	jQuery(this).closest("h3").closest(".filter_block").find(".filter_body").slideToggle(250);
    });
  	
});